import { render } from "./InventarioSkuUbicacionesPage.vue?vue&type=template&id=0385a1cc&scoped=true"
import script from "./InventarioSkuUbicacionesPage.vue?vue&type=script&lang=js"
export * from "./InventarioSkuUbicacionesPage.vue?vue&type=script&lang=js"

import "./InventarioSkuUbicacionesPage.vue?vue&type=style&index=0&id=0385a1cc&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0385a1cc"]])

export default __exports__